import type { AnalyticsSender } from '@funtech-int/yango-shared';

import {
    HeaderNavigatedTo,
    headerNavigated,
    headerShowed,
} from '@kinopoisk-int/evgen-web-events/web/header';

import { PageId } from '@/shared/types/pathId';

const mapPageIdToHeaderNavigatedTo: Partial<Record<string, HeaderNavigatedTo>> = {
    [PageId.MAIN]: HeaderNavigatedTo.MyMoviesScreen,
    [PageId.CHANNELS]: HeaderNavigatedTo.TvchannelsScreen,
    [PageId.PERSONAL]: HeaderNavigatedTo.MypageScreen,
    [PageId.LOGIN]: HeaderNavigatedTo.AuthScreen,
};

const transformPageIdToHeaderNavigatedTo = ({
    hasSubscription,
    pageId,
}: {
    hasSubscription: boolean;
    pageId?: string;
}): HeaderNavigatedTo | undefined => {
    let result = pageId ? mapPageIdToHeaderNavigatedTo[pageId] : undefined;
    if (!result) {
        return undefined;
    }
    if (!hasSubscription && result === HeaderNavigatedTo.MyMoviesScreen) {
        result = HeaderNavigatedTo.OnboardingPlusScreen;
    }

    return result;
};

export const createAnalyticsEvents = (eventSender: AnalyticsSender) => ({
    headerShowed() {
        eventSender.sendOnce(headerShowed, {});
    },
    headerNavigated(pageId: string | undefined, hasSubscription: boolean) {
        const to = pageId
            ? transformPageIdToHeaderNavigatedTo({
                  pageId,
                  hasSubscription,
              })
            : undefined;

        if (to) {
            eventSender.send(headerNavigated, { to });
        }
    },
});
